import { FETCH_EXHIBITIONS_SEARCH_RESULTS } from "../../../../../graphql/query/Exhibition";
import { exhibitionFilterStore } from "../../../components/useExhibitionFilters";

const SearchedExhibitions = props => {
  const tableProps = {
    dataKey: "exhibitionsV2",
    FETCH_QUERY: FETCH_EXHIBITIONS_SEARCH_RESULTS,
    limit: 50,
    variables: {
      ...exhibitionFilterStore.get(),
    },
  };

  return tableProps;
};

export default SearchedExhibitions;
